<!-- HxSwitch Template -->
<label class="hx-switch__wrapper" [attr.for]="computedId()" [class.disabled]="disabledState()">
  <input
    #input
    class="hx-switch__input"
    role="switch"
    type="checkbox"
    [attr.aria-checked]="ariaChecked()"
    [attr.aria-describedby]="ariaDescribedby() || null"
    [attr.aria-label]="ariaLabel() || null"
    [attr.aria-labelledby]="ariaLabelledby() || (computedId() ? computedId() + '-label' : null)"
    [checked]="checked()"
    [disabled]="disabledState()"
    [id]="computedId()"
    [name]="name()"
    (blur)="handleBlur()"
    (keydown)="handleInputKeydown($event)"
    (change)="handleInputChange($event)" />

  <div class="hx-switch__track">
    <!-- Thumb (sliding circle) with icons inside -->
    <div class="hx-switch__thumb">
      <!-- Start Icon Slot (visible when unchecked) -->
      <ng-content select="[hxSwitchStartIcon]" />

      <!-- End Icon Slot (visible when checked) -->
      <ng-content select="[hxSwitchEndIcon]" />
    </div>
  </div>

  <!-- Overlay for hover/focus feedback -->
  <div class="hx-switch__overlay"></div>

  <span class="hx-switch__label" [attr.id]="computedId() ? computedId() + '-label' : null">
    <ng-content select=":not([hxSwitchStartIcon]):not([hxSwitchEndIcon])"></ng-content>
  </span>
</label>
